module.exports = __webpack_public_path__ + "fonts/constellaDrps.4e24a0b.woff";